import { render, staticRenderFns } from "./TechnicTeamOverview.vue?vue&type=template&id=d00c00b2&scoped=true"
import script from "./TechnicTeamOverview.vue?vue&type=script&lang=js"
export * from "./TechnicTeamOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00c00b2",
  null
  
)

export default component.exports